import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry_bestsellers: FaireCategoryEntity = {
  token: "cat_jewelry-bestsellers",
  type: "category",
  name: "Bestsellers",
  level: 2,
  parentToken: "cat_jewelry",
  href: "/category/jewelry/bestsellers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
